const isKiosk = import.meta.env.VITE_APP_TARGET === "kiosk";

export const resolveUrl = (webUrl: string, kioskUrl: string): string =>
  isKiosk ? kioskUrl : webUrl;

export const resolveApiUrl = (
  webUrl: string,
  options?: {
    kioskUrl?: string;
    kioskPublicUrl?: string;
    isAuthenticated?: boolean;
  }
): string => {
  if (!isKiosk) return webUrl;

  const { isAuthenticated = false, kioskPublicUrl, kioskUrl } = options || {};

  if (isAuthenticated && kioskUrl) return kioskUrl;
  if (!isAuthenticated && kioskPublicUrl) return kioskPublicUrl;

  const kioskPath = `/kiosk${webUrl}`;
  return isAuthenticated ? kioskPath : `${kioskPath}public/`;
};

export const getApiPrefix = (isAuthenticated: boolean = false): string => {
  if (!isKiosk) return "";
  return isAuthenticated ? "/kiosk" : "/kiosk/public";
};
